import { formatPaywallCurrencyAmount } from "@/react/helpers/paywalls/currencies";
import { mapCurrencyAmountStrToInt } from "@circle-react/components/Paywalls/Admin/utils";
import { paywallPriceTypes } from "@circle-react/types/PaywallPrice";
import type {
  NoticeScenario,
  NoticeScenarioMatcher,
  NoticeScenarioMessagePropsResolver,
} from "../NoticeScenario.types";
import { recurringStateValidator } from "./StateValidators";

const matcher: NoticeScenarioMatcher = ({
  priceType,
  hasUpfrontPayment,
  hasTrialPeriod,
}) =>
  priceType === paywallPriceTypes.subscription &&
  !hasUpfrontPayment &&
  hasTrialPeriod;
const messagePropsResolver: NoticeScenarioMessagePropsResolver = ({
  buildOptions,
  currency,
  trialPeriodDays,
  watch,
}) => [
  "trial_then_subscription",
  {
    recurring_frequency:
      buildOptions.frequencies[
        watch("billing_frequency")
      ].as_phrase.toLowerCase(),
    recurring_amount: formatPaywallCurrencyAmount(
      currency,
      mapCurrencyAmountStrToInt(watch("amount")),
      {
        amountInCents: true,
        includeCurrencyCode: true,
      },
    ),
    trial_period_days: `${trialPeriodDays}`,
  },
];

export const trialThenSubscription: NoticeScenario = {
  matcher,
  stateValidator: recurringStateValidator,
  messagePropsResolver,
};
